export const environment = {
  production: true,
  serviceUrl: "https://ccgencompass.climatecontrolgroup.com/ccgencompass-be/",
  safariBaseUrl: 'https://ccgspecialfeaturerequest.app.climatecontrolgroup.com/',
  ratingsBaseUrl: 'https://performance.iecokc.com/',
  clmPerformanceBaseUrl: 'https://performance.climatecontrolgroup.com/cmperformancedata-be/',
};
